import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { IUser } from '~/models';
import { Divider } from '~/commonComponents';
import { BadgeList } from '~/commonComponents/BadgeList';
import { AttendanceScoreLevels, BadgeTypes } from '~/constants';
import BadgeIcon from '~/images/attendance/BadgeIcon';
import { RisingStar } from '~/images/attendance/RisingStar';

interface IBadgesCardProps {
  professional: IUser;
}

export const BadgesCard = ({ professional }: IBadgesCardProps) => {
  const professionalStats = professional?.professional_info?.stats;

  const attendanceScoreLevel = professional?.badges?.find(
    (badge) => badge.type === BadgeTypes.AttendanceScore,
  )?.level;

  let badgeInfo = AttendanceScoreLevels.noBadge;
  if (attendanceScoreLevel === 0) {
    badgeInfo = AttendanceScoreLevels.risingStar;
  } else if (attendanceScoreLevel === 1) {
    badgeInfo = AttendanceScoreLevels.bronze;
  } else if (attendanceScoreLevel === 2) {
    badgeInfo =
      professionalStats?.attendanceScore < 100
        ? AttendanceScoreLevels.silver
        : AttendanceScoreLevels.silverSpecial;
  } else if (attendanceScoreLevel === 3) {
    badgeInfo = AttendanceScoreLevels.gold;
  }

  const renderBadge = () => {
    if (!badgeInfo?.rank || badgeInfo?.rank === 'no-badge') {
      return null;
    }

    if (badgeInfo?.rank === 'rising-star') {
      return <RisingStar />;
    }

    return <BadgeIcon rank={badgeInfo?.rank} />;
  };

  return (
    <Column
      pt={6}
      pb={8}
      px={8}
      style={{
        backgroundColor: colors.shades[0],
        borderRadius: 8,
        boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
        overflow: 'hidden',
      }}
    >
      <Column gap={2}>
        <Typography as="span" bold size="heading_4" style={{ marginBottom: 12 }}>
          Badges:
        </Typography>
        <BadgeList professional={professional} />

        {badgeInfo && (
          <>
            <Divider height={1} />

            <Row gap={3} align="start">
              {renderBadge()}
              <Typography as="span">
                <Typography as="span" variant="body1" bold>
                  {badgeInfo.title}:
                </Typography>{' '}
                {badgeInfo.description}
              </Typography>
            </Row>
          </>
        )}
      </Column>
    </Column>
  );
};
